import { NgModule } from '@angular/core';

import { UserLotsPipe } from './user-lots.pipe';

@NgModule({
  imports: [],
  declarations: [UserLotsPipe],
  exports: [UserLotsPipe]
})
export class UserLotsModule { }
